module.exports = [{"title":"Community Resources","items":[{"id":"support.en","title":"Support"}]}]